<script setup>
import { BFormSelect } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';

import yearsData from './top-annual-contributors-page/data';
import YearSection from './top-annual-contributors-page/YearSection.vue';

const selectedYear = ref(yearsData[0]?.year ?? null);

const yearOptions = computed(() =>
  yearsData.map(yearData => ({ value: yearData.year, text: String(yearData.year) })),
);

const selectedYearData = computed(() =>
  yearsData.find(yearData => yearData.year === selectedYear.value) ?? null,
);
</script>

<template>
  <div>
    <h1>Top Annual Contributors</h1>
    <p>
      As an open source project, GitLab has thousands of contributions from the wider
      community. This page highlights top contributors year by year.
    </p>

    <p class="text-muted small">
      Years up to and including 2024 are an archived record imported from
      <code>about.gitlab.com</code> and rank contributors by merged merge requests
      using the original SuperStar / Star / Enthusiast tiers. From 2025 onwards
      we use the contributor platform's own data, ranking by total contribution
      score across all activity types. To keep the lists comparable, only
      contributors with five or more merged merge requests in the year are shown.
    </p>

    <div class="mb-3 d-flex align-items-center">
      <label
        for="top-contributors-year"
        class="me-2 mb-0"
      >Year:</label>
      <BFormSelect
        id="top-contributors-year"
        v-model="selectedYear"
        :options="yearOptions"
        class="w-auto"
      />
    </div>

    <YearSection
      v-if="selectedYearData"
      :key="selectedYearData.year"
      :year-data="selectedYearData"
    />
    <p v-else>No top contributor data available yet.</p>
  </div>
</template>
